import { createHttp } from './http';

const apiClients = new Map();

export const getHttp = (baseURL, withCredentials) => {
    if (!apiClients.has(baseURL)) {
        apiClients.set(baseURL, createHttp(baseURL, withCredentials));
    }

    return apiClients.get(baseURL);
};
